// Catalogo de permisos por modulo. La llave es el campo booleano en User.
export const SECCIONES_PERMISOS = [
  { id: "general", titulo: "General", icono: "fas fa-file-export", color: "#0ea5e9", permisos: [
    ["exportar", "Exportar PDF, Excel y correo de listados"],
    ["imprimir", "Imprimir notas y documentos"],
  ]},
  { id: "vinos", titulo: "Vinos", icono: "fas fa-wine-glass-alt", color: "#3b82f6", permisos: [
    ["menu_articulos", "Ver catalogo de vinos"],
    ["articulos_create", "Crear y editar vinos"],
    ["lineas_create", "Crear y editar tipos de vino"],
    ["familias_create", "Crear y editar regiones"],
    ["colecciones_create", "Crear y editar varietales"],
  ]},
  { id: "compras", titulo: "Compras", icono: "fas fa-file-signature", color: "#6366f1", permisos: [
    ["menu_compras", "Ver compras y recepciones"],
    ["compras_create", "Registrar recepciones"],
    ["compras_cancelar", "Cancelar recepciones"],
    ["menu_oc", "Ver ordenes de compra"],
    ["oc_create", "Crear ordenes de compra"],
    ["oc_editar", "Editar ordenes de compra"],
    ["oc_cancelar", "Cerrar y reabrir ordenes de compra"],
    ["pendiente_recibir", "Ver pendiente por recibir"],
    ["devoluciones_proveedor_create", "Crear devoluciones a proveedor"],
    ["devoluciones_proveedor_aplicar", "Aplicar devoluciones a proveedor"],
    ["menu_proveedores", "Ver proveedores"],
    ["proveedores_create", "Crear y editar proveedores"],
  ]},
  { id: "ventas", titulo: "Ventas", icono: "fas fa-wine-bottle", color: "#10b981", permisos: [
    ["menu_ventas", "Ver ventas"],
    ["ventas_create", "Venta directa"],
    ["ventas_observaciones", "Editar observaciones de ventas"],
    ["menu_pedidos", "Ver pedidos"],
    ["pedidos_create", "Crear pedidos"],
    ["pedidos_editar", "Editar pedidos"],
    ["pedidos_cancelar", "Cancelar pedidos"],
    ["pedidos_autorizar", "Autorizar, abrir y cerrar pedidos"],
    ["menu_surtidos", "Ver surtidos y notas"],
    ["surtidos_create", "Surtir pedidos"],
    ["cancelarNotas", "Cancelar notas"],
    ["entregarNotas", "Marcar ventas como entregadas"],
    ["menu_consignaciones", "Ver consignaciones"],
    ["consignaciones_create", "Crear consignaciones"],
    ["consignaciones_liquidar", "Liquidar consignaciones"],
    ["consignaciones_cancelar", "Cancelar consignaciones"],
    ["cambiaPrecios", "Cambiar precios"],
    ["menu_devoluciones", "Ver devoluciones"],
    ["devoluciones_create", "Crear devoluciones"],
    ["menu_clientes", "Ver clientes"],
    ["clientes_create", "Crear y editar clientes"],
    ["menu_departamentos", "Ver tipos de cliente y zonas"],
    ["tipos_cliente_create", "Crear y editar tipos de cliente"],
    ["zonas_create", "Crear y editar zonas"],
    ["grupos", "Ver grupos de clientes"],
    ["grupos_create", "Crear y editar grupos de clientes"],
  ]},
  { id: "inventarios", titulo: "Inventarios", icono: "fas fa-warehouse", color: "#f59e0b", permisos: [
    ["menu_inventarios", "Ver inventarios"],
    ["inventarios", "Ver existencias y costos"],
    ["menu_disponible", "Ver disponible"],
    ["seguimiento_inventarios", "Ver kardex"],
    ["ajustesInventario", "Crear ajustes"],
    ["autorizarAjustesInventario", "Autorizar ajustes"],
    ["menu_areas", "Ver almacenes"],
    ["areas_create", "Crear y editar almacenes"],
  ]},
  { id: "cobranza", titulo: "Administracion", icono: "fas fa-coins", color: "#8b5cf6", permisos: [
    ["configAdmin", "Ver modulo Admin"],
    ["abonos", "Ver abonos"],
    ["abonosCreate", "Registrar abonos"],
    ["abonos_editar", "Editar abonos"],
    ["abonos_cancelar", "Cancelar abonos"],
    ["edoCtaClientes", "Estado de cuenta de clientes"],
    ["seguimiento_borrar", "Borrar comentarios de seguimiento de cobranza"],
    ["notasCargo", "Ver notas de cargo"],
    ["notasCargoCreate", "Crear notas de cargo y saldos iniciales"],
    ["notas_cargo_editar", "Editar notas de cargo"],
    ["saldo_inicial_editar", "Editar saldos iniciales"],
    ["menuAnticipos", "Ver anticipos"],
    ["anticiposCreate", "Crear anticipos"],
    ["anticipos_editar", "Editar anticipos"],
    ["anticipos_aplicar", "Aplicar anticipos"],
    ["comisiones", "Ver comisiones"],
    ["comisionesCreate", "Crear comisiones"],
    ["comisiones_editar", "Editar comisiones"],
    ["comisiones_pagar", "Pagar comisiones"],
    ["comisiones_cancelar", "Cancelar comisiones"],
    ["menu_devolucionesAdmin", "Ver devoluciones en Admin"],
    ["devoluciones_aplicar", "Editar y aplicar devoluciones"],
    ["bancos", "Ver bancos y movimientos"],
    ["bancos_create", "Crear y editar cuentas de banco"],
    ["bancos_movimientos", "Traspasos entre bancos"],
    ["menu_empresas", "Ver empresas"],
    ["empresas_create", "Crear y editar empresas"],
  ]},
  { id: "cxp", titulo: "Cuentas por pagar", icono: "fas fa-file-invoice-dollar", color: "#ef4444", permisos: [
    ["pagoProveedores", "Ver cuentas por pagar"],
    ["pagoProveedoresCreate", "Registrar pagos"],
    ["pagos_proveedor_cancelar", "Cancelar pagos a proveedores"],
    ["edoCtaProveedores", "Estado de cuenta de proveedores"],
  ]},
  { id: "gastos", titulo: "Gastos", icono: "fas fa-receipt", color: "#14b8a6", permisos: [
    ["menu_gastos", "Ver gastos"],
    ["gastos_create", "Crear gastos"],
    ["gastos_editar", "Editar gastos y evidencias"],
    ["gastos_cancelar", "Cancelar gastos"],
    ["categorias_create", "Crear y editar categorias de gastos"],
    ["subcategorias_create", "Crear y editar subcategorias de gastos"],
    ["solicitantes_create", "Crear y editar solicitantes"],
  ]},
  { id: "empleados", titulo: "Empleados", icono: "fas fa-users", color: "#06b6d4", permisos: [
    ["menu_empleados", "Ver empleados"],
    ["empleados_create", "Crear y editar empleados"],
    ["empleados_sueldo", "Ver sueldos"],
    ["menu_puestos", "Ver puestos"],
    ["puestos_create", "Crear puestos"],
  ]},
  { id: "sistema", titulo: "Reportes y sistema", icono: "fas fa-cog", color: "#64748b", permisos: [
    ["menu_reportes", "Ver reportes"],
    ["menu_usuarios", "Ver usuarios"],
    ["usuarios_create", "Crear y editar usuarios"],
    ["usuarios_permisos", "Cambiar permisos"],
    ["menu_logs", "Ver bitacora"],
  ]},
];

export const LLAVES_PERMISOS = SECCIONES_PERMISOS.flatMap((s) => s.permisos.map(([k]) => k));
